import { Row, Col, Card, message } from 'antd';
import {
  convertCentsIntoDollar,
  formatDate,
} from '../../../helpers/genericHelper';
import CustomText from '../../CustomText';
import { CopyOutlined } from '@ant-design/icons';
import Data from '../../CustomText/data';

function TransactionHistoryComponent({ transactions = [], activities }) {

  return (
    <>
      {(activities && activities.length > 0) ?
        activities.map((activity) => {
          const data = activity
          const isPayment = data.item.creditCardStatementDataEntityType === "PAYMENT"
          return (
            <Card
              bordered={false}
              hoverable={true}
              key={data.id}
              className={
                'criclebox tablespace mb-16' +
                (false && isPayment === true ? ' green-bordered-card' : '')
              }
            >
              <Row>
                <Data isTag tagColor={isPayment ? "default" : "default"} title="Type" value={data.item.creditCardStatementDataEntityType === "PAYMENT" ? "Payment" : "Transaction"} />
                <Data isTag tagColor={data.success ? "success" : "warning"} title="Status" value={data.success ? "SUCCESS" : "PENDING"} />
              </Row>
              &nbsp;
              <Row>
                <Col span="6">
                  <Data title={`${isPayment ? 'Payment' : 'Transaction'} ID`} value={data.id} copyable>{data.id}</Data>
                </Col>
                <Col span="4">
                  <Data title="Date" >{formatDate(data.transactionTime ?? data.time, true)}</Data>
                </Col>
                <Col span="4">
                  <Data title="Descriptor" >{data.item.descriptor}</Data>
                </Col>
                <Col span="4">
                  <Data title="Amount" >{convertCentsIntoDollar(data.item.amount)}</Data>
                </Col>
                <Col span="6">
                  <Data title="Balance" >{convertCentsIntoDollar(activity.item.balance)}</Data>
                </Col>
              </Row>
            </Card>
          )
        }) : (
          <Row className="no-data-card">No Transaction(s) Found</Row>
      )}
    </>
  );
}

export default TransactionHistoryComponent;
